<style>
  .mini-sidebar .header-left .logo img {
    width: 100px;
  }

  .menu-side img {
    width: 22px;
  }

  /* .nav-schedule {
    background-image: url('/themes/theme-default/images/nav/schedule.PNG');
  }

  .help-about {
    color: #fdefef !important;
    font-size: 19px !important;
  }

  .page-sidebar .page-sidebar-menu ul.sub-menu {
    margin: 0px;
  }



  span.ad-sign:after {
    position: absolute;
    display: inline-block;
    content: '\F107';
    right: 5px;
    top: 11px;
    text-align: center;
    background: transparent;
    z-index: 22;
    width: 24px;
    height: 24px;
    line-height: 20px;
    font-weight: bold;
    color: #ddd;
    font-size: 12px;
    transition: transform .25s linear;
    -webkit-transition: -webkit-transform .25s linear;
    font-family: 'fontAwesome';
  }

  span.ad-sign.collapsed:after {
    line-height: 24px !important;
    content: '\F107';
    -webkit-transform: rotate(00deg);
    transform: rotate(00deg);
  }

  span.ad-sign:after {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }


  ul.page-sidebar-menu-closed span.ad-sign {
    display: none;
  }

  ul.page-sidebar-menu>li {
    position: relative;
  }

  .page-sidebar {
    box-shadow: 0px 0px 20px #eee;
  }

  body>div.tooltip.fade.top.in {
    display: none !important;
  }

  span.title {
    font-weight: normal;
  } */
</style>

<div class=" ">
  <div class="main-wrapper">
    <div class="header">
      <div class="header-left">
        <a (click)="router.navigate(['/'])" class="logo">
          <img src="/public/public/img/dhs/DHSCareLogo.png" class="logobig" height="39px" alt="">
          <img src="/public/public/img/dhs/dhssmall.png" class="logosmallsze" height="39px" alt="">



        </a>
      </div>
      <a id="toggle_btn" href="javascript:void(0);" (click)="onToggleSidebar()"><img src="/public/public/img/icons/bar-icon.svg" alt=""></a>
      <a id="mobile_btn" class="mobile_btn float-start" href="#sidebar"><img src="/public/public/img/icons/bar-icon.svg"
          alt=""></a>
      <!-- <div class="top-nav-search mob-view">
        <form>
          <input type="text" class="form-control" placeholder="Search here">
          <a class="btn"><img src="/public/public/img/icons/search-normal.svg" alt=""></a>
        </form>
      </div> -->
      <ul class="nav user-menu float-end">
        <li class="nav-item dropdown d-none ">
          <a href="#" class="dropdown-toggle nav-link" data-bs-toggle="dropdown"><img
              src="/public/public/img/icons/note-icon-02.svg" alt=""><span class="pulse"></span> </a>
          <div class="dropdown-menu notifications">
            <div class="topnav-dropdown-header">
              <span>{{ 'shell.notifications' | translate }}</span>
            </div>
            <div class="drop-scroll">
              <ul class="notification-list">
                <li class="notification-message">
                  <div class="media">
                    <div class="media-body text-center py-3">
                      <p class="noti-details mb-0">{{ 'shell.noRecentNotifications' | translate }}</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="topnav-dropdown-footer">
              <a href="activities.html">{{ 'shell.viewAllNotifications' | translate }}</a>
            </div>
          </div>
        </li>
        <li class="nav-item dropdown d-none ">
          <a href="javascript:void(0);" id="open_msg_box" class="hasnotifications nav-link"><img
              src="/public/public/img/icons/note-icon-01.svg" alt=""><span class="pulse"></span> </a>
        </li>
        <li class="nav-item dropdown has-arrow user-profile-list">
          <a href="#" class="dropdown-toggle nav-link user-link" data-bs-toggle="dropdown">
            <div class="user-names">
              <h5>{{this.securityService.loggedInUser.UserName}} </h5>
              <span>{{ 'shell.userRole' | translate }}</span>
            </div>
            <span class="user-img">
              <img src="/public/public/img/dhs/avatar3.png" [alt]="'shell.userAvatar' | translate">
            </span>
          </a>


          <div class="dropdown-menu">
            <a class="dropdown-item" routerLink="/Employee/ProfileMain">{{ 'shell.myProfile' | translate }}</a>
            <!-- <a class="dropdown-item" href="edit-profile.html">Edit Profile</a>
              <a class="dropdown-item" href="settings.html">Settings</a> -->
            <a class="dropdown-item" (click)="LogoutFromAplication()">{{ 'shell.logout' | translate }}</a>
          </div>
        </li>
        <li class="NavDDL">
          <div class="dropdown">
            <button class="btn dropdown-toggle " type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown"
              aria-expanded="false">
              <img src="./public/public/img/dhs/web.svg" [alt]="'common.toggleLanguage' | translate" />
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">

              <li *ngFor="let lang of languages">

                <button *ngIf="lang.code !== currentLang" class="dropdown-item LangItems"
                  (click)="changeLang(lang.code)">
                  <img [src]="lang.icon" [alt]="lang.label">
                  {{ lang.label }}
                </button>
              </li>
            </ul>
          </div>
        </li>
        <!-- Dark Mode Toggle -->
        <li class="nav-item">
          <a class="hasnotifications nav-link" (click)="darkMode.toggle()" style="cursor:pointer;"
            [title]="(darkMode.isDark ? 'shell.switchToLightMode' : 'shell.switchToDarkMode') | translate">
            <i [class]="darkMode.isDark ? 'bx bx-sun' : 'bx bx-moon'" style="font-size:20px; color: #4e7896;"></i>
          </a>
        </li>
        <!-- Settings: choose the page layout, or open the settings module -->
        <li class="nav-item dropdown layout-settings">
          <a href="javascript:void(0);" class="hasnotifications nav-link" data-bs-toggle="dropdown" aria-expanded="false"
            [title]="'shell.layout.title' | translate" [attr.aria-label]="'shell.layout.title' | translate"><img
              src="/public/public/img/icons/setting-icon-01.svg" alt="">
          </a>
          <div class="dropdown-menu dropdown-menu-end layout-settings-menu">
            <h6 class="dropdown-header">{{ 'shell.layout.title' | translate }}</h6>
            <button type="button" class="dropdown-item" [class.active]="!layout.isTop" (click)="setLayout('sidebar')">
              <i class="bx bx-dock-left" aria-hidden="true"></i> {{ 'shell.layout.sidebar' | translate }}
            </button>
            <button type="button" class="dropdown-item" [class.active]="layout.isTop" (click)="setLayout('top')">
              <i class="bx bx-dock-top" aria-hidden="true"></i> {{ 'shell.layout.top' | translate }}
            </button>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/Settings/DepartmentsManage/Department">
              <i class="bx bx-cog" aria-hidden="true"></i> {{ 'shell.settings' | translate }}
            </a>
          </div>
        </li>
      </ul>
      <div class="dropdown mobile-user-menu float-end">
        <a href="#" class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><i
            class="fa-solid fa-ellipsis-vertical"></i></a>
        <div class="dropdown-menu dropdown-menu-end">
          <a class="dropdown-item" href="profile.html">{{ 'shell.myProfile' | translate }}</a>
          <a class="dropdown-item" href="edit-profile.html">{{ 'shell.editProfile' | translate }}</a>
          <a class="dropdown-item" href="settings.html">{{ 'shell.settings' | translate }}</a>
          <a class="dropdown-item" href="login.html">{{ 'shell.logout' | translate }}</a>
        </div>
      </div>
    </div>
    <div class="sidebar" id="sidebar">
      <div class="sidebar-inner slimscroll">
        <div id="sidebar-menu" class="sidebar-menu">
          <div class="top-nav-search mob-view" style="float: unset; margin-left: 10px;">
            <form style="width: 100% !important;">
              <input type="text" class="form-control" name="searchText" [placeholder]="'common.search' | translate"
                [(ngModel)]="searchText" (input)="onSearchChange()">
              <a class="btn"><img src="/public/public/img/icons/search-normal.svg" alt=""></a>
            </form>
          </div>
          <ul class="mt-2">
            <li class="submenu">
              <a routerLink="/Home"><span class="menu-side"><img src="/public/themes/theme-default/images/nav/home.png"
                    alt=""></span> <span> {{'SideMenue.Home' |translate}} </span> </a>
            </li>
            <li class="submenu" *ngFor="let route of filteredRoutes; let i = index">
              @if (route.UrlFullPath === 'ReportsWave1' && !hasVisibleChildRoutes(route)) {
                <a [routerLink]="routeLink(route)">
                  <span class="menu-side"><img *ngIf="route.Css || route.RouteIcon" src="/public/themes/theme-default/images/nav/{{(route.Css || route.RouteIcon || '').toLowerCase()}}" alt="" /></span>
                  <span>{{ navigationLabel(route) }}</span>
                </a>
              } @else {
              <a style="cursor: pointer;" (click)="toggleSubMenu(route.DisplayName, $event)">
                <span class="menu-side">
                  <img *ngIf="route.Css || route.RouteIcon"
                    src="/public/themes/theme-default/images/nav/{{(route.Css || route.RouteIcon || '').toLowerCase()}}" alt="" />
                </span>
                <span>{{ navigationLabel(route) }} </span>
                <span class="menu-arrow"></span>
              </a>
              }

              <ul [style.display]="openMenus[route.DisplayName] ? 'block' : 'none'" id="{{route.DisplayName}}">
                <ng-container *ngTemplateOutlet="routeChildren; context: { $implicit: route }"></ng-container>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Child menu of a top-level route; shared by the sidebar and the top menu. -->
    <ng-template #routeChildren let-route>
      <ng-container *ngFor="let childroute of route.ChildRoutes">
        <!-- PLAN: FE-PLAN-2026-08-01-systemconfiguration | REQ: REQ-SYSTEMCONFIGURATION-017 -->
        <ng-container
          *ngIf="(isAccountingRoute(route) || isCommissionRoute(route)) && hasVisibleChildRoutes(childroute); else menuChildLink">
          <li class="submenu"
            *ngIf="(childroute != null && childroute.DisplayName.length > 0) && childroute.DefaultShow != false">
            <a class="settings-nested-menu-toggle" role="button" tabindex="0"
              [attr.aria-expanded]="openMenus[childMenuKey(route, childroute)] ? 'true' : 'false'"
              (click)="toggleSubMenu(childMenuKey(route, childroute), $event)"
              (keydown.enter)="toggleSubMenu(childMenuKey(route, childroute), $event)"
              (keydown.space)="toggleSubMenu(childMenuKey(route, childroute), $event)">
              <span class="settings-nested-menu-label">{{ navigationLabel(childroute) }}</span>
              <span class="menu-arrow"></span>
            </a>
            <ul [style.display]="openMenus[childMenuKey(route, childroute)] ? 'block' : 'none'">
              <ng-container *ngFor="let nestedRoute of childroute.ChildRoutes">
                <ng-container *ngIf="isMenuSection(nestedRoute); else nestedMenuLink">
                  <li *ngIf="hasVisibleChildRoutes(nestedRoute)">
                    <span class="accounting-menu-section-label">{{ navigationLabel(nestedRoute) }}</span>
                  </li>
                  <ng-container *ngFor="let sectionRoute of nestedRoute.ChildRoutes">
                    <li
                      *ngIf="(sectionRoute != null && sectionRoute.DisplayName.length > 0) && sectionRoute.DefaultShow != false">
                      <a [routerLink]="routeLink(sectionRoute)" [routerLinkActive]="'left-nav-active'">
                        {{ navigationLabel(sectionRoute) }}
                      </a>
                    </li>
                  </ng-container>
                </ng-container>
                <ng-template #nestedMenuLink>
                  <li
                    *ngIf="(nestedRoute != null && nestedRoute.DisplayName.length > 0) && nestedRoute.DefaultShow != false">
                    <a [routerLink]="routeLink(nestedRoute)" [routerLinkActive]="'left-nav-active'">
                      {{ navigationLabel(nestedRoute) }}
                    </a>
                  </li>
                </ng-template>
              </ng-container>
            </ul>
          </li>
        </ng-container>
        <ng-template #menuChildLink>
          <li
            *ngIf="(childroute != null && childroute.DisplayName.length > 0) && childroute.DefaultShow != false">
            <a [routerLink]="routeLink(childroute)" [routerLinkActive]="'left-nav-active'">
              {{ navigationLabel(childroute) }}
            </a>
          </li>

        </ng-template>
      </ng-container>
    </ng-template>

    <!-- Top menu (layout "top"): the same routes and icons as the sidebar, shown as a bar under the header. -->
    @if (layout.isTop) {
    <nav class="his-topnav" [attr.aria-label]="'shell.layout.top' | translate">
      <ul class="his-topnav-list">
        <li class="his-topnav-item">
          <a class="his-topnav-link" routerLink="/Home" routerLinkActive="active" [title]="'SideMenue.Home' | translate">
            <span class="menu-side"><img src="/public/themes/theme-default/images/nav/home.png" alt=""></span>
            <span class="his-topnav-label">{{ 'SideMenue.Home' | translate }}</span>
          </a>
        </li>
        @for (route of topNavRoutes; track route.DisplayName) {
        <li class="his-topnav-item dropdown" data-topnav-route>
          @if (route.UrlFullPath === 'ReportsWave1' && !hasVisibleChildRoutes(route)) {
          <a class="his-topnav-link" [routerLink]="routeLink(route)" routerLinkActive="active" [title]="navigationLabel(route)">
            <span class="menu-side"><img *ngIf="route.Css || route.RouteIcon" src="/public/themes/theme-default/images/nav/{{(route.Css || route.RouteIcon || '').toLowerCase()}}" alt="" /></span>
            <span class="his-topnav-label">{{ navigationLabel(route) }}</span>
          </a>
          } @else {
          <a class="his-topnav-link" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" data-bs-auto-close="outside"
            aria-expanded="false" [title]="navigationLabel(route)">
            <span class="menu-side"><img *ngIf="route.Css || route.RouteIcon" src="/public/themes/theme-default/images/nav/{{(route.Css || route.RouteIcon || '').toLowerCase()}}" alt="" /></span>
            <span class="his-topnav-label">{{ navigationLabel(route) }}</span>
            <i class="bx bx-chevron-down his-topnav-caret" aria-hidden="true"></i>
          </a>
          <ul class="dropdown-menu his-topnav-menu">
            <ng-container *ngTemplateOutlet="routeChildren; context: { $implicit: route }"></ng-container>
          </ul>
          }
        </li>
        }
        @if (topNavMoreRoutes.length) {
        <li class="his-topnav-item dropdown" data-topnav-more>
          <a class="his-topnav-link" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" data-bs-auto-close="outside"
            aria-expanded="false" [title]="'shell.layout.more' | translate" [attr.aria-label]="'shell.layout.more' | translate">
            <span class="menu-side"><i class="bx bx-dots-horizontal-rounded" aria-hidden="true"></i></span>
          </a>
          <ul class="dropdown-menu dropdown-menu-end his-topnav-menu his-topnav-more">
            @for (route of topNavMoreRoutes; track route.DisplayName) {
            <li class="submenu">
              @if (route.UrlFullPath === 'ReportsWave1' && !hasVisibleChildRoutes(route)) {
              <a [routerLink]="routeLink(route)" [routerLinkActive]="'left-nav-active'">
                <span class="menu-side"><img *ngIf="route.Css || route.RouteIcon" src="/public/themes/theme-default/images/nav/{{(route.Css || route.RouteIcon || '').toLowerCase()}}" alt="" /></span>
                {{ navigationLabel(route) }}
              </a>
              } @else {
              <a class="settings-nested-menu-toggle" role="button" tabindex="0"
                [attr.aria-expanded]="openMenus[route.DisplayName] ? 'true' : 'false'"
                (click)="toggleSubMenu(route.DisplayName, $event)"
                (keydown.enter)="toggleSubMenu(route.DisplayName, $event)"
                (keydown.space)="toggleSubMenu(route.DisplayName, $event)">
                <span class="menu-side"><img *ngIf="route.Css || route.RouteIcon" src="/public/themes/theme-default/images/nav/{{(route.Css || route.RouteIcon || '').toLowerCase()}}" alt="" /></span>
                <span class="settings-nested-menu-label">{{ navigationLabel(route) }}</span>
                <span class="menu-arrow"></span>
              </a>
              <ul [style.display]="openMenus[route.DisplayName] ? 'block' : 'none'">
                <ng-container *ngTemplateOutlet="routeChildren; context: { $implicit: route }"></ng-container>
              </ul>
              }
            </li>
            }
          </ul>
        </li>
        }
      </ul>
    </nav>
    }

    <!--   BEGIN HEADER & CONTENT DIVIDER -->
    <div class="clearfix"> </div>
    <!-- END HEADER & CONTENT DIVIDER -->
    <!-- BEGIN CONTAINER -->
    <div [ngClass]="navService.showTopNav ? '':'' ">

      <!-- BEGIN CONTENT -->
      <div class="page-wrapper" style="min-height: 404px;">
        <div class="content">
          <div class="notification-box">
            <div class="msg-sidebar notifications msg-noti">
              <div class="topnav-dropdown-header">
                <span>{{ 'shell.messages' | translate }}</span>
              </div>
              <div class="drop-scroll msg-list-scroll" id="msg_list">
                <ul class="list-box">
                  <li>
                    <div class="list-item">
                      <div class="list-body text-center w-100 py-3">
                        <span class="message-content">{{ 'shell.noRecentMessages' | translate }}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="topnav-dropdown-footer">
                <a href="chat.html">{{ 'shell.seeAllMessages' | translate }}</a>
              </div>
            </div>
          </div>
          <!-- BEGIN CONTENT BODY -->
          <!-- <his-loading [loading]="loading"></his-loading> -->
          <!-- 4-3-2019 changed by Vikas -->
          <his-loader [loadingScreen]="loadingScreen"></his-loader>
          <!--Vikas: his-loader added for loading display until http request process do not finished-->
          <his-msgbox></his-msgbox>

          <div [ngClass]="navService.showSideNav ? 'page-content':'cstm-pg-content' ">
            <div *ngIf="coreService.loading" class="child-loader">
              <div class="loading-image-holder">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
                </div>
                <!-- <img src="/public/themes/theme-default/images/loading.gif" alt="loading" /> -->
              </div>
            </div>

            <div>
              <router-outlet (activate)="onActivate()"></router-outlet>
            </div>
            <!-- END CONTENT BODY -->
          </div>
        </div>

      </div>
      <!-- END CONTENT -->

    </div>
    <!-- END CONTAINER -->
    <!-- BEGIN FOOTER -->
    <!-- END FOOTER -->
  </div>
</div>

<!-- popu for change default caledar preference for user  -->

<div class="popup-static portlet box portlet-fullscreen" *ngIf="showDatePopup">
  <div class="portlet-body form">
    <!--Model Box Body Start-->
    <div class="form-body clearfix">

      <div class="col-md-4 hidden-xs hidden-sm" style="margin-right: 24px;"> </div>
      <div class="col-md-5">
        <div class="col-md-10 modelbox-div">
          <div class="row">
            <div class="caption" style="color:blue; margin-top: -25px;"> <span>{{ 'shell.datePreference.title' |
                translate }}</span>
              <a style="float:right;margin-right: -10px;" class="btn btn-danger" (click)="Close()"
                [title]="'common.cancel' | translate">X</a>
              <hr />
            </div>
          </div>
          <div class="row">

            <div class="input-group">
              <div class="icheck-inline">
                <label>{{ 'shell.datePreference.currentSelection' | translate }}</label>
                <label class="mt-checkbox mt-checkbox-outline">
                  <input id="AD" name="AD" type="checkbox" (click)="ChangeDatePreference($event)"
                    [(ngModel)]="empPre.en" />
                  <span></span> {{ 'shell.datePreference.englishAd' | translate }} </label>
                <label class="mt-checkbox mt-checkbox-outline">
                  <input id="BS" name="BS" type="checkbox" (click)="ChangeDatePreference($event)"
                    [(ngModel)]="empPre.np" />
                  <span></span> {{ 'shell.datePreference.nepaliBs' | translate }}</label>
              </div>
            </div>
            <div class="form-actions no-border no-padding">
              <input type="button" class="btn primary-btn" style="height: 30px; float: right;" (click)="SaveEmpPref();"
                [value]="'common.save' | translate" />
            </div>

          </div>

        </div>
      </div>
      <div class="col-md-1 hidden-xs hidden-sm" style="margin-right: 24px;"> </div>
    </div>
    <!--Model Box Body End-->
  </div>
</div>
<app-global-loader></app-global-loader>
<app-global-confirmation></app-global-confirmation>
